import { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import { get } from 'lodash';

import Card from 'components/Card';
import ExportButton from 'components/Export/Button';
import Spinner from 'components/Spinner';
import Negoce from '../index';
import NegoceFilters from '../components/NegoceFilter';
import TopNegociantsCard from '../components/TopNegociantsCard';
import TopCustomersCard from '../components/TopCustomersCard';
import KeyIndicatorsNegociantsCard from '../components/KeyIndicatorsNegociantsCard';
import { formatDataOptions, formatDataCheckOptions } from '../helper';

import {
  getDataFilters,
  updateFormNegoce,
  getDataTopNegociants,
  getDataTopCustomers
} from 'actions/negoce';
import { useUserMe } from 'apiTyped/hooks/users.query';

const NegoceContainer = styled.div`
  .negoceRowContainer {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-gap: 25px;
  }

  .pilotageInternContentContainer {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-bottom: 20px;
  }

  @media (max-width: 1400px) {
    .pilotageInternContentContainer {
      grid-template-columns: 1fr;
    }
  }
`;

class PilotageInterne extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  async componentDidMount() {
    await this.formatDataFilters();
    this.findPilotageInterne();
  }

  async formatDataFilters() {
    await this.props.getDataFilters();
    [
      {
        type: 'currentWine',
        data: this.props.wines || [],
        keys: {
          value: 'wine_id',
          label: 'wine_name'
        }
      },
      {
        type: 'currentCampaign',
        data: this.props.campaigns || [],
        keys: {
          value: 'campaign_id',
          label: 'campaign_name'
        }
      },
      {
        type: 'currentSales',
        data: this.props.salesTypes || [],
        keys: {
          value: 'sale_type_id',
          label: 'sale_type_name'
        }
      }
    ].map((filterParams) => {
      this.setDefaultFilter(filterParams);
    });
  }

  setDefaultFilter({ type, data, keys }) {
    const { updateFormNegoce, form } = this.props;
    const typeExist = get(form, type);
    if (!typeExist) {
      const { value, label } = keys;
      const defaultOptions = data.find(({ is_default }) => is_default === true);
      if (defaultOptions) {
        updateFormNegoce({
          [type]: {
            value: get(defaultOptions, value),
            label: get(defaultOptions, label)
          }
        });
      }
    }
  }

  async handleChangeFilters({ type, data }) {
    this.setState({ loading: true });

    if (get(this.props.form, type)) {
      this.setDefaultFilter({
        type,
        data,
        keys: {
          value: 'sale_type_id',
          label: 'sale_type_name'
        }
      });
    }

    await this.props.updateFormNegoce({
      [type]: data
    });
    return this.findPilotageInterne();
  }

  async findPilotageInterne() {
    this.setState({ loading: true });
    const campaignId = get(this.props.currentCampaign, 'value') || -1;
    const saleTypeId = get(this.props.currentSales, 'value') || -1;
    const wineId = get(this.props.currentWine, 'value') || -1;

    await this.props.getDataFilters(campaignId, 'pilotage_interne');
    await this.props.getDataTopNegociants({
      campaignId,
      saleTypeId,
      wineId
    });
    await this.props.getDataTopCustomers({
      campaignId,
      saleTypeId,
      wineId
    });

    this.setState({ loading: false });
  }

  render() {
    const campaignsData = this.props.campaigns || [];
    const salesTypesData = this.props.salesTypes || [];
    const winesData = this.props.wines || [];
    const currentSales = this.props.currentSales;
    const campaignId = get(this.props.currentCampaign, 'value');
    const topNegociants = get(this.props.negociants, 'top_20_negociants', []);
    const negociants = get(this.props.negociants, 'negociants', []);
    const topCustomers = get(this.props.customers, 'top_20_customers', []);
    const availablePresentations = this.props.availablePresentations || [];
    const userLang = get(this.props, 'userLang');

    const optionsCampaign = formatDataOptions(campaignsData, {
      value: 'campaign_id',
      label: 'campaign_name'
    });
    const optionsSales = formatDataCheckOptions(salesTypesData, {
      value: 'sale_type_id',
      label: 'sale_type_name',
      is_default: 'is_default',
      selected_option: get(currentSales, 'value')
    });
    const optionsWine = formatDataOptions(winesData, {
      value: 'wine_id',
      label: 'wine_name'
    });

    const defaultCampain = optionsCampaign[0];
    const defaultCampainId = defaultCampain?.value;

    return (
      <Negoce>
        <NegoceContainer>
          <Card>
            <div className="negoceRowContainer">
              <NegoceFilters
                wineFilter={{
                  selectedOption: this.props.currentWine,
                  options: optionsWine,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentWine',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.wines'),
                  placeholder: I18n.t('negoce.filters.winesPlaceholder')
                }}
                campaignFilter={{
                  selectedOption: this.props.currentCampaign || defaultCampain,
                  options: optionsCampaign,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentCampaign',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.date'),
                  placeholder: I18n.t('negoce.filters.datePlaceholder')
                }}
                salesFilter={{
                  disabled: false,
                  label: I18n.t('negoce.filters.salesTypes'),
                  returnValue: true,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentSales',
                      data: {
                        label: I18n.t('negoce.filters.salesTypes'),
                        value: value
                      }
                    });
                  },
                  radioButtons: optionsSales
                }}
              />
              <ExportButton
                options={availablePresentations}
                paths={{
                  ppt: `/negociant/campaign/${
                    campaignId || defaultCampainId
                  }/ppt_export`
                }}
                params={{
                  ppt: {
                    document_type: 'pilotage_interne',
                    lang: userLang
                  }
                }}
                newApi
              />
            </div>
          </Card>
          <div className="pilotageInternContentContainer">
            <TopNegociantsCard data={topNegociants} />
            <TopCustomersCard data={topCustomers} />
            <KeyIndicatorsNegociantsCard data={negociants} />
          </div>

          <Spinner loading={this.state.loading} />
        </NegoceContainer>
      </Negoce>
    );
  }
}

const Index = (props) => {
  const { user } = useUserMe();
  return <PilotageInterne {...props} userLang={user.language} />;
};

const mapStateToProps = (state) => {
  return {
    salesTypes: state.negoce.data.sale_types,
    campaigns: state.negoce.data.campaigns,
    wines: state.negoce.data.wines,
    negociants: state.negoce.data.pilotage_interne_top_negociants,
    availablePresentations: state.negoce.data.available_presentations,
    customers: state.negoce.data.pilotage_interne_top_customers,
    currentCampaign: state.negoce.form.currentCampaign,
    currentSales: state.negoce.form.currentSales,
    currentWine: state.negoce.form.currentWine,
    form: state.negoce.form
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataFilters: (campaignId, presentationType) =>
      dispatch(getDataFilters(campaignId, presentationType)),
    updateFormNegoce: (data) => dispatch(updateFormNegoce(data)),
    getDataTopNegociants: ({ campaignId, saleTypeId, wineId }) =>
      dispatch(getDataTopNegociants({ campaignId, saleTypeId, wineId })),
    getDataTopCustomers: ({ campaignId, saleTypeId, wineId }) =>
      dispatch(getDataTopCustomers({ campaignId, saleTypeId, wineId }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
